<template>
	<div>
		<div class="tw-text-center tw-mb-8 tw-mt-16">
			<p class="tw-mb-1">
				1. Elegir entre 1 y 2 comportamientos observables por cada competencia.
			</p>
			<p class="tw-mb-1">
				2. Considere que deben ser un mínimo de 9 y máximo 18 comportamientos observables.
			</p>
		</div>
		<three-sixty-help :module-configuration="moduleConfiguration"></three-sixty-help>
	</div>
</template>

<script>
import { pathOr } from 'ramda';
import { mapState } from 'vuex';
import ThreeSixtyHelp from '../../../commons/three-sixty-help';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../../../store/store.constant';

export default {
	name: 'choose-the-job-description',
	components: { ThreeSixtyHelp },
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			moduleConfiguration: pathOr([], ['moduleConfiguration']),
		}),
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/first-step/components/choose-the-job-description.vue